import { AbstractControl, ValidationErrors } from "@angular/forms";

export function multiCheckboxAllRequiredValidator(control: AbstractControl): ValidationErrors | null {
  if(control.value != null && control.dirty && (control as any)._fields[0].props.options.length != control.value.length){
    return { allCheckeboxesRequired: { message: null }}
  }
  return null;
}